import { createSelector } from 'reselect';
import { IAppStore } from '../reducer';

const getHeartRate = (state: IAppStore) => {
  return state.heartRateMonitor.metricResult ?
    state.heartRateMonitor.metricResult.latestHeartRate : null;
};

export const heartRateSelector = createSelector(
  [getHeartRate], (heartRate) => heartRate);

const getIsScanningBelt = (state: IAppStore) => state.heartRateMonitor.isScanningBelt;

export const isScanningBeltSelector = createSelector(
  [getIsScanningBelt], (isScanningBelt) => isScanningBelt);

const getHeartRatePoints = (state: IAppStore) => state.heartRateMonitor.heartRateDataPoints;

export const heartRateDataPointsSelector = createSelector(
  [getHeartRatePoints], (heartRatePoints) => heartRatePoints);

const getMetricResult = (state: IAppStore) => state.heartRateMonitor.metricResult;

export const metricResultSelector = createSelector(
  [getMetricResult], (metricResult) => metricResult);

const getLiveHeartRate = (state: IAppStore) => state.heartRateMonitor.latestLiveHeartRate;

export const liveHeartRateSelector = createSelector(
  [getLiveHeartRate], (heartRateOrNull) => heartRateOrNull);

const getLiveHeartRateSourceType = (state: IAppStore) => state.heartRateMonitor.latestLiveHeartRateSourceType;

export const liveHeartRateSourceTypeSelector = createSelector(
  [getLiveHeartRateSourceType],
  (sourceType) => sourceType,
);

const getLatestConnectedAppHR = (state: IAppStore) => state.heartRateMonitor.latestConnectedAppHR;

export const latestConnectedAppHRSelector = createSelector(
  [getLatestConnectedAppHR],
  (data) => data,
);

const getHeartRateRecieveError = (state: IAppStore) => state.heartRateMonitor.heartRateRecievedError;

export const heartRateRecievedErrorSelector = createSelector(
  [getHeartRateRecieveError], (metricResult) => metricResult);

const getMetricDataHasGoneStale = (state: IAppStore) => state.heartRateMonitor.metricDataHasGoneStale;

export const metricDataHasGoneStaleSelector = createSelector(
  [getMetricDataHasGoneStale], (metricDataHasGoneStale) => metricDataHasGoneStale);

const getHeartRateDeviceList = (state: IAppStore) => state.heartRateMonitor.heartRateDevices;

export const heartRateDeviceListSelector = createSelector(
  [getHeartRateDeviceList], (list) => list);

const getHeartRateDiscoverError = (state: IAppStore) => state.heartRateMonitor.heartRateDiscoverError;

export const heartRateDiscoverErrorSelector = createSelector(
  [getHeartRateDiscoverError], (err) => err);

const getHeartRateDiscoverDidTimeout = (state: IAppStore) => state.heartRateMonitor.heartRateDiscoverDidTimeout;

export const heartRateDiscoverDidTimeoutSelector = createSelector(
  [getHeartRateDiscoverDidTimeout], (didTimeout) => didTimeout);

const getIsRemovingHeartRateIdentifier = (state: IAppStore) => state.heartRateMonitor.isRemovingHeartRateIdentifier;

export const isRemovingHeartRateIdentifierSelector = createSelector(
  [getIsRemovingHeartRateIdentifier], (isRemoving) => isRemoving);

const getIsSavingHeartRateIdentifier = (state: IAppStore) => state.heartRateMonitor.isSavingHeartRateIdentifier;
const getSavingHeartRateIdentifierFailure = (state: IAppStore) => state.heartRateMonitor.savingHeartRateIdentifierFailure;

export const isSavingHeartRateIdentifierSelector = createSelector(
  [getIsSavingHeartRateIdentifier], (isSaving) => isSaving);

export const savingHeartRateIdentifierFailureSelector = createSelector(
  [getSavingHeartRateIdentifierFailure], (errorMessage) => errorMessage);

const getHeartRateSetupStep = (state: IAppStore) => state.heartRateMonitor.heartRateSetupStep;

export const heartRateSetupStepSelector = createSelector(
  [getHeartRateSetupStep], (step) => step);

const getThemeType = (state: IAppStore) => state.heartRateMonitor.themeType;

export const themeTypeSelector = createSelector(
  [getThemeType], (themeType) => themeType);

const getFaqState = (state: IAppStore) => state.heartRateMonitor.faqState;

export const faqStateSelector = createSelector(
  [getFaqState], (faqState) => faqState);

const getHeartRateMonitorDisconnected = (state: IAppStore) => state.heartRateMonitor.heartRateMonitorDisconnected;

export const heartRateMonitorDisconnectedSelector = createSelector(
    [getHeartRateMonitorDisconnected], (disconnected) => disconnected);

export enum HRMonitorConfiguredState {
  notConfigured = 'notConfigured',
  scanning = 'scanning',
  live = 'live',
}

const getHRMonitorConfiguredState = (state: IAppStore): HRMonitorConfiguredState => {
  if (state.heartRateMonitor.latestLiveHeartRate) {
    return HRMonitorConfiguredState.live;
  }
  if (state.heartRateMonitor.isScanningBelt) {
    return HRMonitorConfiguredState.scanning;
  }
  return HRMonitorConfiguredState.notConfigured;
};

export const getHRMonitorConfiguredStateSelector = createSelector(
  [getHRMonitorConfiguredState],
  (state) => state,
)
